export default {
    async getReports(){ 
        try{
            return await ApiClient.get(`/reports`, {embed: ['aggregations.cumulio']})
        } catch(error){
            return error
        }
    },
    async markAsFavorite(identifier){
        return await ApiClient.post(`/reports/${identifier}/favorite`, {})
    },
    async unmarkAsFavorite(identifier){
        return await ApiClient.del(`/reports/${identifier}/favorite`, {})
    },
}